import { Cuboid } from '@App/app/entities/layer/cuboid.model';
import { Component } from '@angular/core';
import { RectLayerPropertiesComponent } from '../rect-layer-properties/rect-layer-properties.component';

@Component({
  selector: 'app-cuboid-properties',
  templateUrl: './cuboid-properties.component.html',
})
export class CuboidPropertiesComponent extends RectLayerPropertiesComponent<Cuboid> {}
